import { SxProps } from "@mui/material";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "100%",
    marginLeft: "60px",
  },
  gritTitle: {
    fontSize: "40px",
    fontWeight: "500",
    fontFamily: "'Steradian', sans-serif",
  },
  searchIcon: {
    width: "16px",
    height: "16px",
    marginRight: "8px",
  },
  tableContainer: {
    "& .grit-table": {
      width: "100%",
      marginBottom: "16px",
      backgroundColor: "linear-gradient(180deg, #FFF 19.96%, #F9F7F8 69.44%);",
      border: "1px solid #E6E6E6",
      borderRadius: "4px",
      fontFamily: "'Steradian', sans-serif",
      overflowX: "auto",

      "& .ant-table": {
        backgroundColor:
          "linear-gradient(180deg, #FFF 19.96%, #F9F7F8 69.44%);",
        border: "none",
      },

      "& .ant-table-container": {
        border: "none",
      },

      "& .ant-table-thead > tr > th": {
        backgroundColor: "transparent !important",
        fontSize: "17px",
        fontWeight: "500",
        fontFamily: "'Steradian', sans-serif",
        border: "none",
        whiteSpace: "nowrap",
        padding: "16px",
      },

      "& .ant-table-tbody > tr > td": {
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: "'Steradian', sans-serif",
        backgroundColor:
          "linear-gradient(180deg, #FFF 19.96%, #F9F7F8 69.44%);",
        padding: "12px 16px",
      },
      "& .ant-pagination": {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginTop: "16px",
      },
    },
  },

  profilePic: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "#f0f0f0",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  filterContainer: {
    width: "100%",
    maxWidth: "100%",
    marginBottom: "16px",
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
  },

  divider: {
    borderColor: "grey.200",
    borderBottomWidth: 2,
    width: "100%",
    marginBottom: "40px",
  },
} satisfies Record<string, SxProps>;

export default styles;
